import { Wire } from "@domain/project/floorplan/wiring/wire";
import { WireRow } from "@pdf/export-services/product-information-pages/floorplan-information-pages/wires/wire-row";
import { TableColumn } from "@pdf/helpers/default-table/table-column";
import { Headlines, ImagePaths, TableProperties } from "@pdf/pdf-properties";
import { jsPDF } from "jspdf";
import { FloorplanInformationTable } from "../floorplan-information-table";

export class WiresRowHeaders {
  public readonly NUMBER = $localize`:@@pdfExport.wiresTable.header.number:Nr.`;
  public readonly DISPLAY_NAME = $localize`:@@pdfExport.wiresTable.header.displayName:Anzeigename`;
  public readonly NAME = $localize`:@@pdfExport.wiresTable.header.name:Name`;
  public readonly TYPE = $localize`:@@pdfExport.wiresTable.header.type:Art`;
  public readonly REFERENCE_LENGTH = $localize`:@@pdfExport.cableRoutesTable.header.referenceLengthInMeter:Länge`;
  public readonly NOTES = $localize`:@@pdfExport.wiresTable.header.notes:Notizen`;
}

export class WiresTable extends FloorplanInformationTable {
  readonly headlines = new Headlines();
  readonly rowHeaders = new WiresRowHeaders();
  override readonly headline = this.headlines.WIRES;
  override readonly columns: TableColumn[];
  override readonly rows: WireRow[];

  constructor(pdf: jsPDF, wires: Wire[]) {
    super(ImagePaths.WIRE);
    this.columns = [
      new TableColumn(this.rowHeaders.NUMBER, 60, 96),
      new TableColumn(this.rowHeaders.DISPLAY_NAME, 180, 156),
      new TableColumn(this.rowHeaders.NAME, 360, 136),
      new TableColumn(this.rowHeaders.TYPE, 520, 146),
      new TableColumn(this.rowHeaders.REFERENCE_LENGTH, 690, 136),
      new TableColumn(this.rowHeaders.NOTES, 850, 590),
    ];

    this.rows = wires.map((wire) => {
      const wireLength = wire.isReferenceMeasureSet() && wire.referenceLength ? `${wire.referenceLength}` : "";
      return new WireRow(
        pdf,
        this.textToColumnWidth(pdf, TableProperties.TEXT_FONT_SIZE, this.preProcessText(wire.positionId), this.rowHeaders.NUMBER),

        this.textToColumnWidth(
          pdf,
          TableProperties.TEXT_FONT_SIZE,
          this.preProcessText(wire.displayName),
          this.rowHeaders.DISPLAY_NAME,
        ),
        this.textToColumnWidth(pdf, TableProperties.TEXT_FONT_SIZE, this.preProcessText(wire.name), this.rowHeaders.NAME),
        this.textToColumnWidth(pdf, TableProperties.TEXT_FONT_SIZE, this.preProcessText(wire.type), this.rowHeaders.TYPE),
        this.textToColumnWidth(
          pdf,
          TableProperties.TEXT_FONT_SIZE,
          this.preProcessText(wireLength),
          this.rowHeaders.REFERENCE_LENGTH,
        ),
        this.textToColumnWidth(pdf, TableProperties.TEXT_FONT_SIZE, this.preProcessText(wire.notes), this.rowHeaders.NOTES),
      );
    });
    this.height = this.calculateHeight(this.rows);
  }
}
